import { render, staticRenderFns } from "./VisitorPassportItem.vue?vue&type=template&id=146359b8&"
import script from "./VisitorPassportItem.vue?vue&type=script&lang=js&"
export * from "./VisitorPassportItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports